const clearResponses = document.querySelector( '[data-clear-responses]' );

if ( clearResponses ) {
	clearResponses.addEventListener( 'click', () => {
		const questionnaire = document.querySelector( '[data-symptoms-questionnaire-form] form' );
		questionnaire.reset();
	});
}
